<template>
<div :class="style.wrapper">
	<Card :class="style.box">
		<div :class="style.content">
			<h1 :class="style.title">{{ appConfig.vendor }}</h1>
			<img v-if="loading" :class="style.loading" src="@/images/loading.gif" alt="loading" />
			<a v-else href="#" :class="style.fbLogin" @click="clickLogin">
				<img src="@/images/fb_icon.png" />
				<span>使用 Facebook 登入</span>
			</a>
		</div>
	</Card>
</div>
<div style="position: absolute;bottom: 20px;color: #aaa; text-align: center; width: 100vw;">Powered by <a style="color: #fff; text-decoration: none;" href="https://pse.is/3u55sj">Happy Buy</a></div>
</template>

<script lang="ts">
import { defineComponent, ref, useCssModule } from 'vue'
import Card from '@/components/Card.vue'

declare var app_config : any

export default defineComponent({
	components: {
		Card,
	},
	setup() {
		const loading = ref(false)
		const clickLogin = () => {
			loading.value = true

			const targetURL = new URL('https://www.facebook.com/v19.0/dialog/oauth')
			targetURL.searchParams.append('client_id', app_config.appId)
			targetURL.searchParams.append('redirect_uri', app_config.redirect_uri)
			targetURL.searchParams.append('state', app_config.client_source)
			targetURL.searchParams.append('scope', "public_profile,email")

			window.location.href = targetURL.href
		}

		return {
			style: useCssModule(),
			appConfig: app_config,
			clickLogin,
			loading,
		}
	}
})
</script>

<style lang="scss" module>
.wrapper {
	height: 100vh;
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;
}

.box {
	min-width: 280px;
	max-width: 90vw;
	width: 500px;
}

.content {
	display: flex;
	margin-bottom: 12px;
	flex-flow: column;
	align-items: center;
}

.title {
	font-size: 1.6rem;
}

.fb-login {
	display: inline-flex;
	border-radius: 5px;
	background: #1877f2;
	color:white;
	text-decoration: none;
	flex-flow: row;
	align-items: center;
	padding: 0 4px;

	& > img {
		margin: 8px;
		width: 24px;
		height: 24px;
	}

	& > span {
		margin-right: 8px;
	}
}

.loading {
	height: 50px;
}
</style>
